module.exports = __webpack_public_path__ + "static/media/service Logo.baea8ff4.svg";